module.exports = __webpack_public_path__ + "static/media/ring_black.30807d37.png";